import { useEffect, useState } from 'react'
import PieChart, {
  Series,
  Label,
  Connector,
  Export as PieChartExport,
  Font,
  Legend,
  PieChartTypes,
} from 'devextreme-react/pie-chart'
import { useTokenRefresh } from '@/auth/azure/azureManager'
import { DataSource, ODataStore } from 'devextreme/common/data'
import notify from 'devextreme/ui/notify'
import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { StatoTicket } from '@/routes/tickets/TicketEditor.enums'
import { Lookup } from 'devextreme-react'
import { ArraySourceComposer } from '@/auth/api/connector'
import { LookupTypes } from 'devextreme-react/cjs/lookup'

const TicketsSummaryCard = () => {
  const token = useTokenRefresh()

  //criteri del raggruppamento della query
  const criteri = [
    { id: 'stato.nome', nome: 'STATO' },
    { id: 'assegnato.fullname', nome: 'ASSEGNATO' },
    { id: 'incaricato.fullname', nome: 'INCARICATO' },
  ]
  const [currentCriteria, setCurrentCriteria] = useState<{ id: string; nome: string }>()

  //array finale di oggetti passato al grafico
  const [graphItems, setGraphItems] = useState<{ key: string; count: number }[]>([])

  const pointClickHandler = (e: PieChartTypes.PointClickEvent) => {
    toggleVisibility(e.target)
  }

  const legendClickHandler = (e: PieChartTypes.LegendClickEvent) => {
    const arg = e.target
    const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0]
    toggleVisibility(item)
  }

  const toggleVisibility = (item: any) => {
    if (item.isVisible()) {
      item.hide()
    } else {
      item.show()
    }
  }

  useEffect(() => {
    let criteria: { id: string; nome: string } = criteri[0]
    const criteriaLocalStorage = localStorage.getItem(`tickets-summary-card-criteria`)
    if (criteriaLocalStorage !== undefined && criteriaLocalStorage !== null && criteriaLocalStorage !== '')
      criteria = JSON.parse(criteriaLocalStorage) satisfies { id: string; nome: string }
    setCurrentCriteria(criteria)
  }, [])

  useEffect(() => {
    if (!token) return

    const newDataSource = new DataSource({
      store: new ODataStore({
        url: `${import.meta.env.VITE_QSADMINAPI_HOST}/ticket`,
        key: 'id',
        keyType: 'Int32',
        version: 4,
        errorHandler: (e) => {
          console.error(e.errorDetails)
          if (!e.errorDetails) return
          notify(
            {
              message: `Errore : ${e.errorDetails?.message}`,
              type: 'error',
              displayTime: 5000,
            },
            {
              position: 'bottom center',
              direction: 'up-push',
            },
          )
        },
        beforeSend: ODataStoreRequestConfiguration(token),
      }),
      filter: [['stato/id', StatoTicket.APERTO], 'or', ['stato/id', StatoTicket.ASSEGNATO]],
      select: [`${currentCriteria?.id}`, 'ded_Dis'],
      group: { selector: currentCriteria ? currentCriteria.id : '', desc: true },
      paginate: false,
    })
    if (currentCriteria)
      newDataSource
        .load()
        .then((data) => {
          console.log('data', data)
          // Transform data into the format required for graphItems
          const transformedData = data.map((item: { key: any; items: any[] }) => ({
            key:
              item.key ??
              (currentCriteria.nome === 'ASSEGNATO'
                ? 'TECNICI'
                : currentCriteria.nome === 'INCARICATO'
                  ? 'NO PRESA IN CARICO'
                  : null),
            count: item.items.reduce((acc: number, subItem: { ded_Dis: string }) => {
              return acc + 1
            }, 0),
          }))
          console.log('transformedData', transformedData)
          // Update the state with the new graph items
          setGraphItems(transformedData)
        })
        .catch((error) => {
          console.error('Data source loading error:', error)
        })
  }, [token, currentCriteria]) // Consolidated useEffect to handle both DataSource creation and loading

  return (
    <>
      <Lookup
        dataSource={ArraySourceComposer('id', criteri)}
        placeholder="Criterio"
        displayExpr="nome"
        value={currentCriteria}
        dropDownCentered={true}
        dropDownOptions={{ showTitle: true, title: 'Criterio', hideOnOutsideClick: true }}
        onValueChanged={(e: LookupTypes.ValueChangedEvent) => {
          console.log('VALUE CHANGED', e.value)
          setCurrentCriteria(e.value)
          localStorage.setItem(`tickets-summary-card-criteria`, JSON.stringify(e.value))
        }}
      />
      <PieChart
        id="ticketsSummaryPie"
        dataSource={graphItems}
        palette="Bright"
        resolveLabelOverlapping="shift"
        onPointClick={pointClickHandler}
        onLegendClick={legendClickHandler}
      >
        <Series argumentField="key" valueField="count">
          <Label
            visible={true}
            customizeText={(arg: { argumentText: string; valueText: string; percentText: string }) => {
              return `${arg.argumentText} <b>${arg.valueText} ticket (${arg.percentText})</b>`
            }}
          >
            <Font size={12} />
            <Connector visible={true} width={1} />
          </Label>
        </Series>
        <Legend
          markerSize={20}
          font={{ size: 15 }}
          itemTextPosition="right"
          customizeText={(pointInfo: { pointColor: string; pointIndex: number; pointName: any }) => {
            return `${pointInfo.pointName} <b>${graphItems.find((value) => value.key === pointInfo.pointName)?.count}</b>`
          }}
        />
        <PieChartExport enabled={true} />
      </PieChart>
    </>
  )
}

export default TicketsSummaryCard
